export var pluginName = "NSerializeJson";
//# sourceMappingURL=Constants.js.map